{
	"title": "Добро пожаловать в StudyHub",
	"skip": "Пропустить",
	"back": "Назад",
	"next": "Далее",
	"saving": "Сохраняем…",
	"stepProgress": "Шаг {current} из {total}",
	"language": {
		"title": "Выбери язык",
		"subtitle": "Язык интерфейса. Можно изменить позже в настройках.",
		"uiLanguageLabel": "Язык интерфейса",
		"uiLanguagePlaceholder": "Выбери язык…",
		"continue": "Продолжить"
	},
	"method": {
		"title": "Как здесь учатся",
		"lead": "Единица обучения — не файл, а тема. Каждая тема проходит один и тот же маршрут из трёх шагов.",
		"step1": {
			"body": "Конспект, аудио, схема или глоссарий — чтобы структура темы стала видимой. Шаг короткий: запоминание происходит не здесь."
		},
		"step2": {
			"body": "Карточки и тест, где ответ нужно достать из памяти. Перед ответом вы отмечаете, насколько уверены, — уверенная ошибка разбирается первой."
		},
		"step3": {
			"body": "Проверка показывает не оценку, а конкретные места, где ответ не сложился. Дальше работа идёт с ними: голосом, карточками, разбором."
		},
		"science": "Порядок собран вокруг техник, которые в обзорах учебных методов получают высшую оценку полезности.",
		"link": "Подробнее о методе"
	},
	"firstCourse": {
		"title": "С чего начнём",
		"lead": "Курс можно собрать по теме, взять готовый из каталога или начать с пустого пространства под свои материалы. Своих файлов ни один сценарий не требует.",
		"cta": "Создать первый курс",
		"skip": "Пропустить — вернусь позже"
	},
	"rhythm": {
		"title": "Сколько времени в день",
		"lead": "На основе этого мы построим календарный план по всем вашим материалам: разложим темы, повторы и дедлайны по дням. Пропустите занятие — план пересоберётся.",
		"minutesLabel": "Минут в день",
		"minutesCustom": "Свой вариант",
		"daysLabel": "Дни обучения",
		"hint": "Изменить можно в любой момент в настройках.",
		"saveFailed": "Не удалось сохранить ритм занятий",
		"goalFailed": "Календарь настроен, но дневную норму сохранить не удалось",
		"minutesHint": "Сколько времени вы готовы уделять учёбе в обычный день. План не будет ставить больше.",
		"daysHint": "В какие дни недели планировать занятия. В остальные дни план будет пустым."
	},
	"done": {
		"title": "Готово",
		"lead": "Дальше — загружайте материалы, создавайте собственные курсы либо начинайте обучение по курсу из каталога.",
		"cta": "На главную"
	},
	"howItWorks": {
		"title": "Как это работает",
		"tabs": {
			"method": "Метод",
			"course": "Как собрать курс",
			"tools": "Инструменты"
		},
		"tools": {
			"lead": "Инструменты сгруппированы по тому, что вы делаете: читать, смотреть, слушать, практиковаться, планировать."
		},
		"link": "Подробнее о методе"
	}
}
